import {Injectable} from "@angular/core";
import {NavigationEnd, Router, UrlTree} from "@angular/router";
import {Location} from "@angular/common";
import {combineLatest} from "rxjs";
import {filter, map} from "rxjs/operators";
import {UserService} from "../common/user.service";
import {IShopUser} from "../session/customer-models";
import {ShareableUtil} from "../social/shareable-util";

@Injectable({
    providedIn: 'root'
})
export class ReferralUrlService {

    constructor(
        private readonly router: Router,
        private readonly location: Location,
        private readonly userService: UserService
    ) {}

    init(): void {
        const navigationEnd$ = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(event => event)
        );
        const shopUser$ = this.userService.watchShopUser().pipe(
            filter((user: IShopUser) => !!user)
        );

        combineLatest([navigationEnd$, shopUser$]).subscribe(
            ([event, user]: [NavigationEnd, IShopUser]) => {
                const urlTree: UrlTree = this.router.parseUrl(event.urlAfterRedirects);
                const isSponsorEligible: boolean = ShareableUtil.canSponsor(user);

                if (!user?.token || !isSponsorEligible) {
                    if (urlTree.queryParams['ref']) {
                        const {ref, ...remainingParams} = urlTree.queryParams;
                        urlTree.queryParams = remainingParams;
                        this.location.replaceState(this.router.serializeUrl(urlTree));
                    }
                    return;
                }

                const refCode: string = user.siteSubdomain || (user.customerId ? String(user.customerId) : null);
                if (!refCode) {
                    return;
                }

                if (urlTree.queryParams['ref'] === refCode) {
                    return;
                }

                urlTree.queryParams = {...urlTree.queryParams, ref: refCode};
                this.location.replaceState(this.router.serializeUrl(urlTree));
            }
        );
    }
}
